import React, { useCallback, useRef } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

const UPLOADS = "/uploads/";
const isOnUploads = value => value === UPLOADS;

const DragAndDropUpload = ({ onUpload, onlyOnUploads = true }) => {
  const { pathname } = useLocation();

  const dropRef = useRef(null);
  const textRef = useRef(null);

  const addClass = () => {
    dropRef.current?.classList?.add("drag-and-drop--focused");
    textRef.current?.classList.replace("hidden", "drag-and-drop-text");
  };

  const removeClass = () => {
    dropRef.current?.classList?.remove("drag-and-drop--focused");
    textRef.current?.classList?.replace("drag-and-drop-text", "hidden");
  };

  const handleDragOver = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();

    addClass();
  }, []);

  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();

    const { files } = e.dataTransfer || {};

    if (files && files.length) {
      onUpload({ files: Array.from(files) });
    }

    removeClass();
  };

  React.useEffect(() => {
    const { current } = dropRef || {};
    document?.addEventListener("dragover", handleDragOver);
    current?.addEventListener("drop", handleDrop);
    current?.addEventListener("dragleave", removeClass);

    return () => {
      document?.removeEventListener("dragover", handleDragOver);
      current?.removeEventListener("drop", handleDrop);
      current?.removeEventListener("dragleave", removeClass);
    };
  }, []);

  if (onlyOnUploads && !isOnUploads(pathname)) {
    return null;
  }

  return (
    <>
      <div id="drag-and-drop-zone" ref={dropRef} className="drag-and-drop">
        <span id="drag-and-drop-text" ref={textRef} className="hidden">
          Drop files here to upload
        </span>
      </div>
    </>
  );
};

DragAndDropUpload.propTypes = {
  onUpload: PropTypes.func.isRequired,
  onlyOnUploads: PropTypes.bool
};

export default DragAndDropUpload;
